export const getFootnoteId = (id: string | number): string => {
  return `footnote-${id}`
}
